// 新协议
function kkmhhybrid_receiveFreecardChange(opt) {
  hybrid({
    hybridParam: {
      schema: "kkmhhybrid",
      tagname: "receive_freecard_change",
    },
    param: {},
    on: true,
    callback: function (res) {
      opt.callback && opt.callback(res);
    }
  });
}

// 旧协议
function window_reciveFreecardInfo(opt) {
  window.recivefreecardinfo = function (res = {}) {
    var fomatRes = res;
    if(typeof res === 'string'){
      fomatRes = JSON.parse(res);
    }
    opt.callback && opt.callback(fomatRes)
  };
}

/**
 * receive_freecard_change(接收网卡信息)<br>
 * kkmh.recivefreecardinfo,wiki地址{@link https://wiki.quickcan.com/pages/viewpage.action?pageId=37521263}<br>
 * kkmhhybrid://receive_freecard_change,wiki地址：{@link https://wiki.quickcan.com/pages/viewpage.action?pageId=188974748}<br>
 * @param {Object} opt 参数对象
 * @param {Function} opt.callback 回调函数
 * @param {Number} criticalAppVersion 新旧协议兼容的判断版本（默认值在hybrid/index.js里配置），客户端版本小于该值使用旧协议，其余使用新协议
 */
function receive_freecard_change(opt, criticalAppVersion) {
  var allow = window.kkBaseInfo.allowToKkmhhybrid(criticalAppVersion,554000);
  if (allow) {
    // 调用新协议
    kkmhhybrid_receiveFreecardChange(opt);
  } else {
    // 调用旧协议
    window_reciveFreecardInfo(opt);
  }
}

export default receive_freecard_change;


// WEBPACK FOOTER //
// ./node_modules/@kk/h5-sdk/src/receive_freecard_change/index.js